import SelectInputBox from '../Common/SelectInputBox';

const SelectInputBoxWrapper = ({ ...objProps }) => {
  return <SelectInputBox {...objProps.field} {...objProps} />;
};

export default SelectInputBoxWrapper;
